import { useEffect, useContext } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { SidebarContext } from '../context/SidebarContext';

/**
 * Bridge component that connects AuthContext and SidebarContext.
 * Registers a callback with AuthContext to apply sidebar preference after login.
 */
const SidebarAuthBridge = ({ children }) => {
  const { registerLoginCallback } = useAuth();
  const { applyPreference } = useContext(SidebarContext);

  useEffect(() => {
    // Register callback to apply sidebar preference when user logs in
    const unregister = registerLoginCallback((preferences) => {
      if (preferences && applyPreference) {
        applyPreference(preferences);
      }
    });

    // Cleanup on unmount
    return unregister;
  }, [registerLoginCallback, applyPreference]);

  return children;
};

export default SidebarAuthBridge;
